import request from 'sb-request'
// import algoliasearch from 'algoliasearch'
import { reducers } from 'redux/core'
import { links } from 'common/helpers'


const modifyResult = ({ items, bestsellers, exactBrandMatch, exactTypeMatch, ...rest }) => ({
  isBestsellers: bestsellers,
  isExactTypeMatch: exactTypeMatch,
  isExactBrandMatch: exactBrandMatch,
  items: items.map(({ id, url, ...item }) => ({
    id,
    url: url || `${links.searchResult}?item=${id}`,
    ...item,
  })),
  ...rest,
})

const fetch = (query) =>
  request.get('rest/search/quick/new', {
    query: {
      query: String(query),
    },
    modifyResult,
  })
    .then((data) => reducers.models.search.set(data))

// eslint-disable-next-line
const clear = reducers.models.search.clear

const setSearchValue = (value) => reducers.models.search.setSearchValue(value)

// const algoliaClient = appConfig.publicKeys.algoliaAppId && appConfig.publicKeys.algoliaApiKey ? algoliasearch(
//   appConfig.publicKeys.algoliaAppId,
//   appConfig.publicKeys.algoliaApiKey,
// ) : null

// const { services: { algoliaPrefix } } = appConfig

/**
 * Fetches one specific passed algolia index with query and hits length
 *
 * @param {Object} [options]
 * @param {*} [options.index]
 * @param {string} [options.query]
 * @param {number} [options.hits]
 * @returns {Promise<*>}
 */
const fetchAlgoliaIndex = ({ index, query, hits = 5 } = {}) =>
  new Promise((resolve, reject) => {
    index.search(
      {
        query,
        hitsPerPage: hits,
        clickAnalytics: true,
        analytics: true,
      },
      (error, content) => {
        if (error) {
          reject(error)
        }

        resolve(content)
      }
    )
  })

let algoliaIndexes = null

/**
 * Fetches all algolia indexes with query
 *
 * @param {string} query
 * @returns {Promise<object>}
 */
const fetchFromAlgolia = async (query) => {
  // let { models: { me: { gender } } } = getState()

  // if (!algoliaIndexes) {
  //   algoliaIndexes = {
  //     products: {
  //       male: algoliaClient ? algoliaClient.initIndex(`${algoliaPrefix}_products_male`) : null,
  //       female: algoliaClient ? algoliaClient.initIndex(`${algoliaPrefix}_products_female`) : null,
  //     },
  //     brands: algoliaClient ? algoliaClient.initIndex(`${algoliaPrefix}_brands`) : null,
  //     notes: algoliaClient ? algoliaClient.initIndex(`${algoliaPrefix}_notes`) : null,
  //     pages: algoliaClient ? algoliaClient.initIndex(`${algoliaPrefix}_pages`) : null,
  //   }
  // }

  // if (!gender) {
  //   gender = 'female'
  // }

  // const dataArray = await Promise.all(
  //   Object.keys(algoliaIndexes).map((key) => {
  //     let index = algoliaIndexes[key]

  //     if (key === 'products') {
  //       index = algoliaIndexes[key][gender]
  //     }

  //     return new Promise((resolve) => {
  //       const failedData = {
  //         key,
  //         hits: [],
  //         queryID: '',
  //         indexName: index && index.indexName ? index.indexName : '',
  //       }

  //       if (!index) {
  //         return resolve(failedData)
  //       }

  //       fetchAlgoliaIndex({
  //         index,
  //         query,
  //       })
  //         .then(
  //           ({ hits, queryID }) => {
  //             resolve({
  //               key,
  //               hits,
  //               queryID,
  //               indexName: index.indexName,
  //             })
  //           },
  //           (error) => {
  //             sentry.captureException(error)
  //             resolve(failedData)
  //           }
  //         )
  //     })
  //   })
  // )

  // const data = dataArray.reduce(
  //   (object, { key, hits, queryID, indexName }) => ({
  //     ...object,
  //     [key]: {
  //       hits,
  //       queryID,
  //       indexName,
  //     },
  //   }),
  //   {}
  // )

  // reducers.models.search.setAlgoliaItems(data)

  // return data
}


export default {
  fetch,
  clear,
  setSearchValue,
  fetchFromAlgolia,
}
